import React from 'react';
import { genURL } from '../../../_getjson';
import axios from 'axios';
import { DataGrid, GridToolbarQuickFilter, GridToolbar, GridToolbarContainer, } from '@mui/x-data-grid';
import { Box, Button, Stack } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import DraggableDialog from '../../CustomDialogs/DraggableDialog';
import APlist from '../../CustomAPInput/Components/APlist';
import PropTypes from "prop-types";
import DeleteIcon from '@mui/icons-material/Delete';
import PlaylistAddRoundedIcon from '@mui/icons-material/PlaylistAddRounded';

export default function APListCode(props) {
    const { defaultValue } = props
    const [loading, setLoading] = React.useState(false)
    const [data, setData] = React.useState([])
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [searchData, setSearchData] = React.useState("")
    const [openModel, setOpenModel] = React.useState(false)
    const [typeModel, setTypeModel] = React.useState("")
    const [clickRowsID, setClickRowsID] = React.useState("")
    const [buttonText, setButtonText] = React.useState("")
    const [title, setTitle] = React.useState("เลือกเจ้าหนี้")
    const [sendData, setSendData] = React.useState(false)
    React.useEffect(() => {
        getData()
        return () => {
        }
    }, [])

    React.useEffect(() => {
        console.log("defaultValue APListCode", defaultValue);
        if (defaultValue.length > 0) {
            setData(defaultValue)
        }
        return () => {
        }
    }, [defaultValue])

    React.useEffect(() => {
        if (sendData === true) {
            props.resultData(data)
        }
        return () => {
        }
    }, [data])
    const getData = async () => {
        let rows = []
        for (let index = 0; index < 5; index++) {
            rows.push({ id: index + 1, code: "" })
        }
        await setData(rows)
    }
    const columns = [
        { field: 'id', headerName: 'ID', width: 90 },
        {
            field: 'code',
            headerName: 'รหัส',
            width: 30,
            editable: true,
            flex: 1
        },
        {
            field: 'selectAP',
            headerName: '',
            sortable: false,
            width: 34,
            renderCell: (params) => {

                const onClick = () => {
                    setTypeModel("inRow")
                    setClickRowsID(params.id);
                    setOpenModel(true)
                };
                return <SearchRoundedIcon onClick={onClick} sx={{ cursor: "pointer" }}>Click</SearchRoundedIcon>;
            },
        },
    ];
    const handleDoubleClick = (e) => {
        // console.log(selectionModel);  
        let result = []
        if (selectionModel.length > 0) {
            result = data.filter((elem) => {
                return selectionModel.some((ele) => {
                    return ele === elem.id
                });
            });
        } else {
            result.push(e.row)
        }
        props.resultData(result)
    }
    const searchInputKeyUp = (e) => {
        if (e.key === "Enter") {
            setSearchData(e.target.value)
        }
    }
    const handleAddRows = async () => {
        let arrObjIds = await data.map(elements => {
            return elements.id
        });
        let ids = 0
        if (arrObjIds.length > 0) {
            ids = await Math.max(...arrObjIds)
            // console.log("ids", ids)
        }
        //  await setData(...data, { id: ids + 1, code: "" })
        await setData(data => [...data, { id: ids + 1, code: "" }])
        console.log("ids", ids)

        // setTypeModel("addButton")
        // setOpenModel(true)
    }
    const CustomToolbar = () => {
        return (
            <>
                <GridToolbarContainer id={`GridToolbarContainers`} >
                    <Button Button variant="outlined" startIcon={<PlaylistAddRoundedIcon />} size='small' sx={{ marginRight: 2 }} onClick={_ => handleAddRows()}>
                        เพิ่ม
                    </Button>
                    {selectionModel.length > 0 ?
                        <Button Button variant="outlined" startIcon={<DeleteIcon />} size='small' sx={{ marginRight: 2 }} onClick={_ => handleDeleteRows()}>
                            ลบ
                        </Button> : ""
                    }
                    <GridToolbarQuickFilter />
                </GridToolbarContainer >
            </>
        );
    }
    const resultData = async (e) => {
        console.log(e);
        let resultFilter = await data.filter((elem) => {
            return e.find((el => {
                return el.code === elem.code
            }))
        })


        let arrObjIds = await data.map(elements => {
            return elements.id;
        });

        let maxID = 0
        if (arrObjIds.length > 0) {
            maxID = await Math.max(...arrObjIds);
        } else {
            await setData([])
        }
        if (maxID === 0) {
            maxID + 1
        }

        //console.log("resultData maxID", maxID, "resultFilter", resultFilter);  
        await setSendData(true)
        if (resultFilter.length <= 0) {
            if (typeModel === "inRow") {
                // 👇️ passing function to setData method
                setData(data => {
                    const newState = data.map(obj => {
                        // 👇️ if id equals 2, update the country property
                        if (obj.id === clickRowsID) {
                            return { ...obj, code: e[0]["code"] };
                        }
                        // 👇️ otherwise return the object as is
                        return obj;
                    });
                    return newState;
                });

            } else {
                await setData(data => [...data, { id: maxID + 1, code: e[0]["code"] }])
            }
            if (typeModel === "inRow") {
                await setOpenModel(false)
            }
        }
    }
    const handleDeleteRows = async () => {
        console.log(selectionModel);
        let result = []
        if (selectionModel.length > 0) {
            result = data.filter((elem) => {
                return !selectionModel.some((ele) => {
                    return ele === elem.id
                });
            });
        }
        await setData(result)
    }
    return (
        <Box sx={{ height: 400, width: '100%', mt: 2 }}>
            {loading == true ? "กำลังโหลด..." :
                <DataGrid
                    rows={data}
                    columns={columns}
                    sx={{
                        fontFamily: "Customfont !important"
                    }}
                    disableColumnFilter
                    disableColumnSelector
                    disableDensitySelector
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                        // filter: {
                        //     filterModel: {
                        //         items: [],
                        //         quickFilterValues: ['quick', 'filter'],
                        //     },
                        // },
                    }}
                    pageSizeOptions={[10]}
                    checkboxSelection
                    disableSelectionOnClick
                    onSelectionModelChange={(newSelectionModel) => {
                        setSelectionModel(newSelectionModel);
                    }}
                    selectionModel={selectionModel}
                    onRowDoubleClick={e => handleDoubleClick(e)}
                    //  onRowClick={e => handleClick(e)}
                    experimentalFeatures={{ newEditingApi: true }}
                    components={{
                        Toolbar: CustomToolbar,
                        // LoadingOverlay: LinearProgress,
                    }}
                />}
            <DraggableDialog open={openModel} title={title} buttonText={buttonText} closeDialog={_ => setOpenModel(false)}>
                <APlist resultData={e => resultData(e)} />
            </DraggableDialog>
        </Box>

    )

}

APListCode.propTypes = {
    defaultValue: PropTypes.array
}